import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useEffect, useRef } from "react"
import DocumentDraftBootstrapPage from "../../../../../components/WMS/shared/DocumentDraftBootstrapPage"
import { useCreateRW } from "../../../../../components/WMS/Transfers/RW/useCreateRW"

export const Route = createFileRoute("/_layout/WMS/documents/doc-rw/new")({
  component: CreateRWDraftPage,
})

// CreateRWDraftPage is a compatibility bootstrap route, not a second editor.
function CreateRWDraftPage() {
  const navigate = useNavigate()
  const { createRW, isCreating, isResolvingWarehouses, canCreate } =
    useCreateRW()
  const initializedRef = useRef(false)

  useEffect(() => {
    if (initializedRef.current || isResolvingWarehouses || !canCreate) return
    initializedRef.current = true
    createRW()
  }, [canCreate, createRW, isResolvingWarehouses])

  const handleCancel = () =>
    navigate({
      to: "/WMS/documents/document-list",
      search: { page: 1, page_size: 50 },
    })

  return (
    <DocumentDraftBootstrapPage
      title="Utwórz dokument RW"
      onCancel={handleCancel}
      isBusy={isCreating || isResolvingWarehouses}
      canCreate={canCreate}
      busyLabel="Tworzenie szkicu RW..."
      idleLabel="Przygotowywanie edycji dokumentu RW..."
    />
  )
}
